import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadUserFromAzure, setUserPreferences } from '../../actions/user';
import { msalInstance, msalScope } from '../../helpers/azure';

export const Azure = ({ history }) => {
    const [localError, setLocalError] = React.useState('');
    const dispatch = useDispatch();

    const redirectPath = useSelector(state => state.user.redirectPath);
    const error = useSelector(state => state.user.errorMessage);

    const azure = (account, callback) => dispatch(loadUserFromAzure(account, callback));

    const loginToE4enable = msalInstance => {
        const account = msalInstance.getAccount();

        const redirect = redirectPath ? redirectPath : '/';

        azure(account, () => history.push(redirect));
    };

    React.useEffect(() => {
        msalInstance.handleRedirectCallback((error, response) => {
            // if error is not null, something went wrong
            // if not, response is a successful login response
        });

        if (msalInstance.getAccount()) {
            msalInstance
                .acquireTokenSilent(msalScope)
                .then(res => {
                    // set token in sessionStorage
                    const { accessToken, expiresOn } = res;
                    sessionStorage.setItem('access_token', accessToken);
                    sessionStorage.setItem('token_expiration', expiresOn);

                    // get user info from graph api
                    loginToE4enable(msalInstance);
                })
                .catch(err => {
                    console.error(err);
                    setLocalError('Failed to log you in. This could be because your browser is blocking 3rd party cookies.');
                });
        } else {
            msalInstance.loginRedirect(msalScope);
        }
    }, []);

    if (error || localError)
        return (
            <div className="flex flex-center flex-column">
                <h3 id="WelcomeMessage">Logging into e4enable from Azure AD...</h3>
                <div className="mt20 text-center">
                    <p>
                        <span id="json">{error || localError}</span>
                    </p>
                    <p>Please check with your administrator that your company are using Azure SSO</p>
                    <p>with e4enable and that you are set up correctly.</p>
                </div>
                <div className="mt20">
                    <a href="/login" className="btn btn-primary">
                        Back to login
                    </a>
                </div>
            </div>
        );

    return (
        <div className="flex flex-center flex-column">
            <h3 id="WelcomeMessage">Logging into e4enable from Azure AD...</h3>
            <div>
                <i className="fa fa-spin fa-cog text-lg mr10" />
                <span id="json">Please Wait</span>
            </div>
        </div>
    );
};

export default Azure;
